module.exports = __webpack_public_path__ + "img/stock2.12872f0c.png";